import { EmailSpecification } from '.';

export class LoggedEmail {
    constructor(
        public specification:EmailSpecification,
        public to:string,
        public sent:Date,
        public success:boolean,
        public trace:string
    ){}
}